import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./SpaceTemplateCard.module.less";
import { useCallbackWithoutArguments } from "client/Hooks";

export type SpaceTemplateCardProps = {
	name: string;
	description: string;
	thumbnailUrl?: string;
	isSelected: boolean;
	onClick: () => void;
	onDoubleClick: () => void;
	trackingId: string;
};

export const SpaceTemplateCard = (props: SpaceTemplateCardProps): ReactElement => {
	const {
		name,
		description,
		thumbnailUrl,
		isSelected,
		onClick: onClickFromProps,
		onDoubleClick: onDoubleClickFromProps,
		trackingId
	} = props;

	const onClick: () => void = useCallbackWithoutArguments(onClickFromProps);
	const onDoubleClick: () => void = useCallbackWithoutArguments(onDoubleClickFromProps);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{ [styles.root_selected]: isSelected }
			)}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
		>
			<div
				className={styles.thumbnail}
				title={name}
			>
				{thumbnailUrl && (
					<img
						src={thumbnailUrl}
						alt={name}
					/>
				)}
			</div>
			<h4 className={styles.title}>
				{name}
			</h4>
			<div className={styles.description}>
				{description}
			</div>
		</div>
	);
};
SpaceTemplateCard.displayName = "SpaceTemplateCard";